import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import {
  Grid, Box, useTheme, useMediaQuery,
} from '@mui/material';
import { TourCardSkeleton } from 'views/common/components';

const MotorcycleRentalsSectionSkeleton = () => {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const getnumber = () => {
    let n;
    if (isTablet && !isMobile) {
      n = 2;
    } else if (isTablet && isMobile) {
      n = 1;
    } else {
      n = 4;
    }
    return n;
  };
  return (
    <Box className="MTSSContainer" py={4}>
      <Skeleton variant="text" width="30%" height={40} />
      <Skeleton
        variant="text"
        width="15%"
        height={40}
        sx={{ marginBottom: theme.spacing(2) }}
      />
      <Grid container spacing={2}>
        {Object.keys([...Array(getnumber())]).map((item) => (
          <Grid item xs={12} md={6} lg={3} key={item}>
            <TourCardSkeleton />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export { MotorcycleRentalsSectionSkeleton };
